module.exports = __webpack_public_path__ + "static/img/room.c20c590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/room.png
// module id = nskM
// module chunks = 1